import { post } from '@/services/Axios';
import qs from 'qs';
import errorHandler from '@/mixins/errorHandler';
import { mapState } from 'vuex';

export default {
  mixins: [errorHandler],
  data() {
    return {
      profile: {},
      loadProfile: false,
      loadingFormProfile: false,
      loadFormProfile: false
    };
  },
  computed: mapState(['user']),
  methods: {
    async getProfile() {
      this.loadProfile = true;
      try {
        const data = this.$store.dispatch('getProfile');
        this.Profile = data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadProfile = false;
      }
    },
    async updateProfile(request) {
      this.loadFormProfile = true;
      const requestBody = {
        account_id: this.user.accountId,
        account_name: request.account_name,
        account_mobilephone: request.account_mobilephone,
        account_email: request.account_email,
        account_code: this.user.accountCode,
        account_group_id: this.user.accountAccountGroupId,
        account_position: this.user.accountPosition,
        account_unit_id: this.user.accountUnitId
      };
      const payload = qs.stringify(requestBody);
      try {
        const { data } = await post('/user/update', { data: payload });
        this.$store.dispatch('getProfile');
        return data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadFormProfile = false;
      }
    },
    async updatePassword(request) {
      this.loadFormProfile = true;
      const requestBody = {
        account_id: this.user.accountId,
        password: request.password,
        password_confirmation: request.password_confirmation
      };
      const payload = qs.stringify(requestBody);
      try {
        const { data } = await post('/user/change-password', { data: payload });
        return data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadFormProfile = false;
      }
    },
    async updateAvatar(url) {
      this.loadFormProfile = true;
      const requestBody = {
        account_id: this.user.accountId,
        account_avatar: url
      };
      const payload = qs.stringify(requestBody);
      try {
        const { data } = await post('/user/update-avatar', { data: payload });
        this.$store.dispatch('getProfile');
        return data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadFormProfile = false;
      }
    }
  }
};
